import { useQuery } from '@tanstack/react-query';
import { fetchAllCitiesList } from '../data-provider/city-list';
import type { AllCitiesListRequestParams } from '../data-provider/city-list/api';

export const useGetCityList = ({
  isDisabled,
  ...params
}: Partial<AllCitiesListRequestParams> & { isDisabled: boolean }) => {
  return useQuery({
    queryKey: ['all-city-list', params.CountryCode, params.StateCode],
    queryFn: () => fetchAllCitiesList(params as AllCitiesListRequestParams),
    staleTime: Number.POSITIVE_INFINITY, // loaded only once
    enabled: !!params.CountryCode && !!params.StateCode && !isDisabled,
  });
};
